import * as types from './mutation-types.js'

const mutations = {
  [types.SET_USERINFO] (state, data) {
    state.userInfo = data
  },
  [types.SET_ACCOUNT] (state, data) {
    state.account = data
  },
  [types.SET_ORGINFO] (state, data) {
    state.orgInfo = data
  },
  [types.SET_PERMISSION] (state, data) {
    state.permission = data
  },
  [types.SET_TOKEN] (state, data) {
    state.token = data
  },
  [types.SET_SESSIONKEY] (state, data) {
    state.sessionKey = data
  },
  [types.SET_B2BDEFSUPPID] (state, data) {
    state.b2bDefSuppId = data
  },
  [types.SET_SHPINFO] (state, data) {
    state.shpInfo = data
  },
  [types.SET_CARTCOUNT] (state, data) {
    state.cartCount = data
  },
  [types.SET_GODTYPELIST] (state, data) {
    state.godTypeList = data
  },
  [types.SET_NAVIBARITEMLIST] (state, data) {
    state.naviBarItemList = data
  },
  [types.SET_SHPSEARCHBAR] (state, data) {
    state.shpSearchBar = data
  },
  [types.SET_CARTLIST] (state, data) {
    state.cartList = data
  },
  [types.SET_TRDACTIVITYS] (state, data) {
    state.trdActivitys = data
  }
}

export default mutations
